module.exports = __webpack_public_path__ + "img/good.e8a2e7f0.svg";